import SDK from '../sdk/utils'

export default () => {
  const {height, width} = window.screen
  
  return SDK.isIos && height === 812 && width === 375
}